import router, { resetRouter } from '@/router'
import store from '@/store'
import { getToken, removeToken, setToken } from '@/utils/cookies'
import { setStaffMenuTree } from '@/utils/local-storage'
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { usePermissionStore } from './permission'
import { useSettingsStore } from './settings'
import { useTagsViewStore } from './tags-view'
import { defaultClinicCode, setDefaultClinicCode } from './login'
// 依赖
import IndexDB from '@/utils/indexdb'
// 方法
import { parseJwt } from '@/utils/cookies'
import { getStaffMenuTree } from '@/utils/local-storage'
import { toTree, flatFunc } from '@/utils/tree'
// api
import { loginByAccount, getStaffMenu } from '@/api/user'
// hooks
import { useClinicCodeList } from '@/layouts/hooks/useClinicList'
import { resetDictionaries } from '@/common/src/hooks/useDictionaries'
// import { getChannelManager } from '@/common/src/service/worker'
// 常量
// import { type LoginRequestData } from '@/api/login/types/login'
import { MENU_1_ID } from '@/constants/app-key'
import routeSettings from '@/config/route'
import { type RouteRecordRaw } from 'vue-router'
import { isEn } from '@/locales/index'

export const useUserStore = defineStore('user', () => {
  const routeMap = ref<Record<string, any>>({})
  const token = ref<string>(getToken() || '')
  const roles = ref<string[]>([])
  // 賬號名稱
  const accountName = ref<string>('')
  // 用戶信息
  const userInfo = ref<Record<string, any>>({})
  // 路由权限
  const staffMenuInfo = ref<Record<string, any>>({})

  const permissionStore = usePermissionStore()
  const tagsViewStore = useTagsViewStore()
  const settingsStore = useSettingsStore()
  const { setClinicCodeList } = useClinicCodeList()

  // 是否诊所跳过来的
  const isFromClinic = computed(() => {
    return !!userInfo.value?.clinicCode
  })
  const currentClinicCode = computed(() => {
    return userInfo.value?.clinicCode
  })

  // 同域跨项目通信：监听其他项目/标签页登录通知，更新当前页用户名
  // const channelManager = getChannelManager({ name: 'tcma-cross-tab' })
  // channelManager.connect()
  // channelManager.subscribe('user-login', (msg) => {
  //   // 忽略本项目发来的通知
  //   if (msg.source === 'tcma-clinic-manager') return
  //   console.log('[BroadcastChannel] 收到同域登录通知，更新用户信息:', msg)

  //   const tokenIn = getToken()
  //   const jwtPayload = parseJwt(tokenIn)
  //   if (jwtPayload) {
  //     userInfo.value = jwtPayload
  //   }
  // })

  /** 设置角色数组 */
  const setRoles = (value: string[]) => {
    roles.value = value
  }
  /** 登录 - 组织 */
  const login = async (params: Record<string, any>, option?: Record<string, any>) => {
    console.log('login == ', params, option)
    const res: Record<string, any> = await loginByAccount(params, option)
    if (res?.accessToken) {
      setToken(res.accessToken)
      token.value = res?.accessToken
    }
  }
  /** 获取用户详情 */
  const getInfo = async () => {
    // const { data } = await getUserInfoApi()
    const tokenIn = getToken()
    const jwtPayload = parseJwt(tokenIn)
    if (jwtPayload && jwtPayload.isAdmin !== undefined) {
      const val = jwtPayload.isAdmin
      // 統一處理成 bool 的 false
      if (val === 'false' || val === 'False' || val === false) {
        jwtPayload.isAdmin = false
      } else {
        jwtPayload.isAdmin = !!val
      }
    }
    console.log('jwtPayload == ', jwtPayload)
    console.log('defaultClinicCode.value == ', defaultClinicCode.value)
    console.log('jwtPayload.clinicCode == ', jwtPayload?.clinicCode)
    userInfo.value = jwtPayload
    console.log('userInfo.value.clinicCode == ', userInfo.value?.clinicCode)
    // 如果是诊所级，给当前诊所对code给到defaultClinicCode
    if (!!jwtPayload?.clinicCode) {
      if (defaultClinicCode.value !== jwtPayload.clinicCode) {
        // defaultClinicCode.value = jwtPayload.clinicCode
        setDefaultClinicCode(jwtPayload.clinicCode)
        console.log('userInfo.value.clinicCode == ', userInfo.value?.clinicCode)
      }
    }
    // {
    //   userId: '3332795960770871296',
    //   userName: '黎泉',
    //   userEnName: 'Allen Barry',
    //   currentId: '3332796009877782528',
    //   clinicCode: 'test',
    //   clinicName: '中醫診所-HK中醫診所-HK中醫診所-H',
    //   sysRole: 2,
    //   isAdmin: false,
    //   isGuest: false,
    // }
    // 用户名称等信息
    // const loginStoreUserInfo = getUserInfo()
    // if (loginStoreUserInfo) {
    //   userInfo.value = loginStoreUserInfo
    // } else {
    //   userInfo.value = await getLoginUser()
    //   setUserInfo(userInfo.value)
    // }
    // console.log('loginStoreUserInfo == ', loginStoreUserInfo)
    // 用户可用菜单
    let staffMenuList = getStaffMenuTree()
    // console.log('staffMenuList == ', staffMenuList)
    if (!staffMenuList) {
      staffMenuList = await getStaffMenu({
        menuCategory: MENU_1_ID,
      })
      setStaffMenuTree(staffMenuList)
    }
    // // const staffMenuList = await getStaffMenu({
    // //   menuCategory: MENU_1_ID
    // // }) // 用户可用菜单
    // // staffMenuList.map

    const staffMenuTree = toTree(staffMenuList, MENU_1_ID)
    flatFunc(routeMap.value, staffMenuTree)
    console.log('staffMenuList staffMenuTree == ', staffMenuList, staffMenuTree)
    console.log('routeMap.value == ', routeMap.value)

    const data = {
      account: 'admin',
      roles: ['admin'],
    }
    console.log('userInfo.value == ', userInfo.value)
    console.log('isEn.value == ', isEn.value)
    if (isEn.value) {
      accountName.value = userInfo.value.enName || userInfo.value.name
    } else {
      accountName.value = userInfo.value.name
    }
    // 验证返回的 roles 是否为一个非空数组，否则塞入一个没有任何作用的默认角色，防止路由守卫逻辑进入无限循环
    roles.value = data.roles?.length > 0 ? data.roles : routeSettings.defaultRoles
    // roles.value = userInfo.value?.sysRole ? [userInfo.value?.sysRole] : routeSettings.defaultRoles
  }
  /** 切换角色 */
  const changeRoles = async (role: string) => {
    const newToken = 'token-' + role
    token.value = newToken
    setToken(newToken)
    await getInfo()
    console.log('bb routeMap.value == ', routeMap.value)
    permissionStore.setRoutes(roles.value, routeMap.value)
    resetRouter()
    permissionStore.dynamicRoutes.forEach((item: RouteRecordRaw) => {
      router.addRoute(item)
    })
    _resetTagsView()
  }
  /** 登出 */
  const logout = async (next?: boolean) => {
    return new Promise<boolean>((resolve, reject) => {
      if (token.value) {
        logoutFn(next)
        resolve(true)
        // outLogin()
        //   .then(() => {
        //     logoutFn(next)
        //     resolve(true)
        //   })
        //   .catch((err) => {
        //     resolve(false)
        //   })
      } else {
        logoutFn(next)
        resolve(true)
      }
    })
  }
  const logoutFn = async (next?: boolean) => {
    resetDictionaries()
    removeToken()
    token.value = ''
    roles.value = []
    userInfo.value = {}
    routeMap.value = {}
    // setUserInfo()
    setStaffMenuTree()
    resetRouter()
    _resetTagsView()
    // 清空诊所列表
    setClinicCodeList([])
    // 移除接口的indexDB缓存
    const removeAllResult = (await IndexDB.removeAll()) || []
    console.log('removeAllResult == ', removeAllResult)
    const removeAllList: string[] = removeAllResult?.content || []
    await Promise.all(
      removeAllList.map((vk) => {
        return IndexDB.remove(vk)
      }),
    )
    if (!next) {
      router.push('/login')
    }
  }
  /** 重置 Token */
  const resetToken = () => {
    removeToken()
    token.value = ''
    roles.value = []
  }
  /** 重置 Visited Views 和 Cached Views */
  const _resetTagsView = () => {
    if (!settingsStore.cacheTagsView) {
      tagsViewStore.delAllVisitedViews()
      tagsViewStore.delAllCachedViews()
    }
  }

  return {
    token,
    roles,
    accountName,
    routeMap,
    userInfo,
    setRoles,
    login,
    getInfo,
    changeRoles,
    logout,
    resetToken,
    isFromClinic,
    currentClinicCode,
  }
})

/** 在 setup 外使用 */
export function useUserStoreHook() {
  return useUserStore(store)
}
